module.exports = __webpack_public_path__ + "img/sportstraderightsection.925f2586.png";